import router from "./index";
// 判断token是否存在
import store from "../store/index"

router.beforeEach((to,from,next)=>{
  // 用户未登录
  if(!store.state.UserToken){
    // 不需要登录
    if(to.matched.length>0&&!to.matched.some(record=>record.meta.requireAuth)){
      next()
    }else {
      // 未登录，页面需要登录
      next({
        path:'/login'
      })
    }
  }else {
     // 用户已经登录  路由的访问权限
      if(!store.state.permission.permissionList){
        store.dispatch("permission/FETCH_PERMISSION").then(() =>{
            next({
                path:to.path
            })
        })
      }else{
          // store存在权限
          // console.log(store.state.UserToken)
          if(to.path !== "/login"){
              next();
          }else{
              next(from.fullPath)
          }
      }
  }
  
  // console.log(to.matched)
})